import { render, staticRenderFns } from "./CapitalApplicationForUse.vue?vue&type=template&id=b4910204&scoped=true&"
import script from "./CapitalApplicationForUse.vue?vue&type=script&lang=ts&"
export * from "./CapitalApplicationForUse.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalApplicationForUse.vue?vue&type=style&index=0&id=b4910204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4910204",
  null
  
)

export default component.exports